export default __webpack_public_path__ + "static/media/ic_Hamburger_menu.f4d477a6.svg";